import { render, staticRenderFns } from "./ModalPop.vue?vue&type=template&id=746ae06a&"
import script from "./ModalPop.vue?vue&type=script&lang=js&"
export * from "./ModalPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports